import { render, staticRenderFns } from "./subFileInput.vue?vue&type=template&id=05cb880d"
import script from "./subFileInput.vue?vue&type=script&lang=js"
export * from "./subFileInput.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports